import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
export default {
  name: "AppCard",
  components: {},
  props: {
    data: {
      type: Object
    }
  },
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      url: ""
    };
  },
  computed: _objectSpread({}, mapGetters(["userToken"])),
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    changeCollect: function changeCollect() {
      var _this = this;

      if (this.data.collection) {
        this.$http.delete("/personal/collection/delCo", {
          params: {
            serveId: this.data.id
          }
        }).then(function (_ref) {
          var data = _ref.data;

          if (data.resCode == 0) {
            _this.$message.success(data.resMsg);

            _this.data.collection = !_this.data.collection;
            _this.data.favoriteCount--;

            _this.$emit("change-collect");
          }

          _this.loading = false;
        }).catch(function () {
          _this.loading = false;
        });
      } else {
        this.$http.post("/personal/collection/newCo", this.$qs.stringify({
          serveId: this.data.id
        })).then(function (_ref2) {
          var data = _ref2.data;

          if (data.resCode == 0) {
            _this.$message.success(data.resMsg);

            _this.data.collection = !_this.data.collection;
            _this.data.favoriteCount++;

            _this.$emit("change-collect");
          }

          _this.loading = false;
        }).catch(function () {
          _this.loading = false;
        });
      }
    },
    clickItem: function clickItem() {
      switch (this.data.serveType) {
        case 0:
          this.$router.push({
            path: "/serveSearch/".concat(this.data.id, "/").concat(this.data.interfaceUrl)
          });
          break;

        case 1:
          this.$router.push({
            path: "/serveApproval/".concat(this.data.id)
          });
          break;

        case 2:
          this.$router.push({
            path: "/serveCustomized/".concat(this.data.id, "/").concat(this.data.interfaceUrl)
          });
          break;

        case 9:
          this.$http.post("/statistical/serverInsert", this.$qs.stringify({
            serviceId: this.data.id,
            appType: 9
          })).then(function () {}).catch(function () {});
          this.url = this.data.linkUrl;
          this.$refs.url.click();
          break;

        default:
          break;
      }
    }
  },
  watch: {},
  filters: {
    serveType: function serveType(value) {
      switch (value) {
        case 0:
          return "查询类";

        case 1:
          return "审批类";

        case 9:
          return "外部连接";

        default:
          break;
      }
    }
  }
};